<template>
  <NuxtLayout>
    <TextHeader />
    
    <section v-if="page.holidays?.length" class="holidayTypesList__ListingWrapper container defaultSectionMargins">
      <div v-for="(item, index) in page.holidays" class="holidayTypesList__ListingItem">
        <Flare :src="item.image" width="620" height="720" size="both" crop="fill" :alt="item.image" :lazy="index <= 3 ? false : true" :fetchPriority="index <= 3 ? 'high' : ''" />
        <h2 v-text="item.name" />
        <p v-text="item.description" />
        <nuxt-link :to="item.sef">{{ item.name }}</nuxt-link>
      </div>
    </section>
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });
  
  defineProps({
    page: {}
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_holidayTypesList.scss');
</style>